import React, { useState, useEffect } from 'react';
import { Line, Bar } from 'react-chartjs-2';

import ReactFC from "react-fusioncharts";

// Step 3 - Include the fusioncharts library
import FusionCharts from "fusioncharts";

// Step 4 - Include the chart type
import Column2D from "fusioncharts/fusioncharts.charts";

// Step 5 - Include the theme as fusion
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";

import styles from './Chart.module.css';

// Step 6 - Adding the chart and theme as dependency to the core fusioncharts
ReactFC.fcRoot(FusionCharts, Column2D, FusionTheme);

const Chart = ({ data, country }) => {

  var DeathsArray = [];
  var ConfirmedArray = [];
  var RecoveredArray = [];
  var DateArray = [];

  var tdn = [], tdc = [], tcn = [], tcc = [], trn = [], trc= [], 
    tndn = [], tndc = [], tncn = [], tncc = [], tnrn = [], tnrc = [];

  if(country) {
    var dailyData = data["countryAllData"];
    console.log("dailyData");
    //console.log(dailyData[0]["Date"] + "fjhg\n");

    var index = 0; 
  
    if(dailyData) {
      dailyData.forEach(myFunction); 
      function myFunction(item, index) 
      { 
        DeathsArray.push(item["Deaths"]);
        ConfirmedArray.push(item["Confirmed"]);
        RecoveredArray.push(item["Recovered"]);
        DateArray.push(item["Date"].slice(0, 10));
      }
    }

    //console.log(DeathsArray);

  } else {
    var NewConfirmed = data["NewConfirmed"];
    var TotalConfirmed = data["TotalConfirmed"];
    var NewDeaths = data["NewDeaths"];
    var TotalDeaths = data["TotalDeaths"];
    var NewRecovered = data["NewRecovered"];
    var TotalRecovered = data["TotalRecovered"];
    var td = data["td"];
    var tc = data["tc"];
    var tr = data["tr"];
    var tnd = data["tnd"];
    var tnc = data["tnc"];
    var tnr = data["tnr"];
    var date = data["date"];
   
    if(td) {
      var index1 = 0;
      var index2 = 0;
      var index3 = 0;
      var index4 = 0;
      var index5 = 0;
      var index6 = 0;
      td.forEach(myFunction1); 
      function myFunction1(item, index1) 
      {
        //var obj = {};
        // obj["label"] = item["country"];
        // obj["value"] = item["totalDeaths"];
        // tdn.push(obj);
        tdn.push(item["totalDeaths"]);
        tdc.push(item["country"]);
        console.log("see this");
        console.log(tdn);
        console.log(tdc);
      }

      tc.forEach(myFunction2); 
      function myFunction2(item, index2) 
      {
        tcn.push(item["totalConfirmed"]);
        tcc.push(item["country"]);
      }

      tr.forEach(myFunction3); 
      function myFunction3(item, index3) 
      {
        trn.push(item["totalRecovered"]);
        trc.push(item["country"]);
      }

      tnd.forEach(myFunction4); 
      function myFunction4(item, index4) 
      {
        tndn.push(item["newDeaths"]);
        tndc.push(item["country"]);
      }

      tnc.forEach(myFunction5); 
      function myFunction5(item, index5) 
      {
        tncn.push(item["newConfirmed"]);
        tncc.push(item["country"]);
      }

      tnr.forEach(myFunction6); 
      function myFunction6(item, index6) 
      {
        tnrn.push(item["newRecovered"]);
        tnrc.push(item["country"]);
      }
    }
  }

  // if(!tdn && !trn && !tcn && !tndn && !tnrn && !tncn && !DateArray) {
  //   return (
  //     <div>
  //       <br />
  //       <div className={styles.loading}>Loading...</div>
  //       <br />
  //     </div>
  //   );
  // }


  const barChart1 = (
    (tdn.length > 0) ? (
      <Bar
        data={{
          labels: tdc,
          datasets: [
            {
              label: 'Country',
              backgroundColor: ['#B71C1C', '#B71C1C', '#B71C1C', '#B71C1C', '#B71C1C'],
              data: tdn,
            },
          ],
        }}
        options={{
          legend: { display: false },
          title: { display: true, text: "Top 5 Countries in terms of total no. of Deaths" },
          scales: {
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: "Total Deaths"
              }
            }],
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: "Countries"
              }
            }],
          }
        }}
      />
    ) : null
  );

  const barChart2 = (
    (tndn.length > 0) ? (
      <Bar
        data={{
          labels: tndc,
          datasets: [
            {
              label: 'Country',
              backgroundColor: ['#B71C1C', '#B71C1C', '#B71C1C', '#B71C1C', '#B71C1C'],
              data: tndn,
            },
          ],
        }}
        options={{
          legend: { display: false },
          title: { display: true, text: "Top 5 Countries in terms of new Death cases" },
          scales: {
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: "New Deaths"
              }
            }],
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: "Countries"
              }
            }],
          },
        }}
      />
    ) : null
  );

  const barChart3 = (
    (trn.length > 0) ? (
      <Bar
        data={{
          labels: trc,
          datasets: [
            {
              label: 'Country',
              backgroundColor: ['#33691E', '#33691E', '#33691E', '#33691E', '#33691E'],
              data: trn,
            },
          ],
        }}
        options={{
          legend: { display: false },
          title: { display: true, text: "Top 5 Countries in terms of total no. of Recoveries" },
          scales: {
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: "Total Recoveries"
              }
            }],
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: "Countries"
              }
            }],
          },
        }}
      />
    ) : null
  );

  const barChart4 = (
    (tnrn.length > 0) ? (
      <Bar
        data={{
          labels: tnrc,
          datasets: [
            {
              label: 'Country',
              backgroundColor: ['#33691E', '#33691E', '#33691E', '#33691E', '#33691E'],
              data: tnrn,
            },
          ],
        }}
        options={{
          legend: { display: false },
          title: { display: true, text: "Top 5 Countries in terms of new no. of Recoveries" },
          scales: {
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: "New Recoveries"
              }
            }],
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: "Countries"
              }
            }],
          },
        }}
      />
    ) : null
  );

  const barChart5 = (
    (tcn.length > 0) ? (
      <Bar
        data={{
          labels: tcc,
          datasets: [
            {
              label: 'Country',
              backgroundColor: ['#FBC02D', '#FBC02D', '#FBC02D', '#FBC02D', '#FBC02D'],
              data: tcn,
            },
          ],
        }}
        options={{
          legend: { display: false },
          title: { display: true, text: "Top 5 Countries in terms of total no. of Confirmed cases" },
          scales: {
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: "Total Infected"
              }
            }],
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: "Countries"
              }
            }],
          },
        }}
      />
    ) : null
  );

  const barChart6 = (
    (tncn.length > 0) ? (
      <Bar
        data={{
          labels: tncc,
          datasets: [
            {
              label: 'Country',
              backgroundColor: ['#FBC02D', '#FBC02D', '#FBC02D', '#FBC02D', '#FBC02D'],
              data: tncn,
            },
          ],
        }}
        options={{
          legend: { display: false },
          title: { display: true, text: "Top 5 Countries in terms of new confirmed cases" },
          scales: {
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: "New Confirmed cases"
              }
            }],
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: "Countries"
              }
            }],
          },
        }}
      />
    ) : null
  );

  const lineChart = (
    (DateArray.length > 0) ? (
      <Line
        data={{
          width: 1600,
          labels: DateArray,
          datasets: [{
            data: ConfirmedArray,
            label: 'Infected',
            borderColor: '#FBC02D',
            pointBackgroundColor: '#FBC02D',
            fill: true,
          }, {
            data: DeathsArray,
            label: 'Deaths',
            borderColor: '#B71C1C',
            //backgroundColor: 'rgba(255, 0, 0, 0.5)',
            pointBackgroundColor: '#B71C1C',
            fill: true,
          }, {
            data: RecoveredArray,
            label: 'Recovered',
            borderColor: '#33691E',
            //backgroundColor: '#00C853',
            pointBackgroundColor: '#33691E',
            fill: true,
          }],
        }}
      />
    ) : null
  );

  if(country) {
    return (<div className={styles.containerLine}>{ lineChart }</div>);
  } else {
    return (
      <div className={styles.container}>
        <div className={styles.barChartDiv}>{barChart1}</div>  
        <div className={styles.barChartDiv}>{barChart2}</div>
        <div className={styles.barChartDiv}>{barChart3}</div>
        <div className={styles.barChartDiv}>{barChart4}</div>
        <div className={styles.barChartDiv}>{barChart5}</div>
        <div className={styles.barChartDiv}>{barChart6}</div>
      </div>
    )
  }

};

export default Chart;
